import useConfig from '@hooks/useConfig';
import Script from 'next/script';

const Chat = () => {
  const { config } = useConfig();
  const { RELEASY_CHAT_HOST, RELEASY_SCRIPT } = config || {};

  if (!RELEASY_CHAT_HOST || !RELEASY_SCRIPT) {
    return null;
  }
  return (
    <>
      {/***
       * if we plan to use the BankID features from Releasy in the future, we will also need to include qrcode.js *
      <Script src="https://cdn.jsdelivr.net/npm/qrcode@1.5.1/build/qrcode.js" /> */}
      <Script
        id="data-chatframe"
        data-lang="sv_SE"
        strategy="afterInteractive"
        data-chaturl={RELEASY_CHAT_HOST}
        data-chaturlcss="static/css/CustomerChatCSSHemkop.css"
        defer
      />
      <Script strategy="afterInteractive" defer src={`${RELEASY_CHAT_HOST}/static/js/${RELEASY_SCRIPT}.js`} />

      <div data-testid="chatframe" id="chatframe" className="chatframe" />
    </>
  );
};

export default Chat;
